import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';
import { PipesModule } from '@fcom/common/pipes';

import { IconsModule } from '../icons/icons.module';
import { PopoverModule } from '../popover/popover.module';
import { TextInputComponent } from './text-input/text-input.component';
import { SelectInputComponent } from './select-input/select-input.component';
import { ButtonModule } from '../buttons';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { AttachmentListComponent } from './file-uploader/attachment-list.component';
import { NotificationsModule } from '../notifications';
import { LoaderModule } from '../loader';
import { RadioItemGroupComponent } from './radio-item-group/radio-item-group.component';
import { ComboBoxComponent } from './combo-box/combo-box.component';
import { CheckboxInputComponent } from './checkbox-input/checkbox-input.component';

@NgModule({
  declarations: [
    AttachmentListComponent,
    FileUploaderComponent,
    RadioItemGroupComponent,
    TextInputComponent,
    SelectInputComponent,
    ComboBoxComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    UiTranslateModule,
    IconsModule,
    ButtonModule,
    CheckboxInputComponent,
    PipesModule,
    PopoverModule,
    NotificationsModule,
    LoaderModule,
  ],
  exports: [
    AttachmentListComponent,
    FileUploaderComponent,
    CheckboxInputComponent,
    RadioItemGroupComponent,
    TextInputComponent,
    SelectInputComponent,
    ComboBoxComponent,
  ],
})
export class FcomFormsModule {}
